import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { Webhook, Webhooks } from '@models/webhook';
import { OverlayService } from '@services/overlay';
import { CloseOverlayKeyboardDirective, CloseOverlayClickDirective } from '../../directives/close-overlay.directives';
import { FormsModule } from '@angular/forms';
import { I18nValueDirective } from '../../directives/i18n.directives';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lv-webhook-form',
  templateUrl: 'webhook-form.component.html',
  styleUrls: ['webhook-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CloseOverlayKeyboardDirective, FormsModule, I18nValueDirective, CloseOverlayClickDirective, TranslateModule]
})
export class WebhookFormComponent {
  private webhookService = inject(Webhooks);
  private overlayService = inject(OverlayService);

  @Input() webhook: Webhook;

  get title(): string {
    return `webhook-form.component.title.${this.webhook.newRecord()}`;
  }

  save() {
    this.webhookService.$save(this.webhook).then(
      () => this.overlayService.closeTopOverlay(),
      (webhook: Webhook) => console.error(webhook.$error)
    );
  }
}
